type EnvConfig = {
  readonly REACT_APP_PLACE_ID: string;
};

/**
 * Gets the pub/venue ID dynamically.
 * Priority:
 * 1. Runtime injection from Lambda@Edge (window.__VENUE_CONFIG__.pubId)
 * 2. Build-time environment variable (REACT_APP_PLACE_ID) - for local development
 */
export const getPubId = (): string => {
  // Check if injected by Lambda@Edge at runtime
  if (typeof window !== "undefined" && window.__VENUE_CONFIG__?.pubId) {
    return window.__VENUE_CONFIG__.pubId;
  }
  // Fallback to env var for local development
  const envValue = process.env.REACT_APP_PLACE_ID;
  if (!envValue) {
    throw new Error(
      "Missing venue ID: Neither window.__VENUE_CONFIG__.pubId nor REACT_APP_PLACE_ID is set"
    );
  }
  return envValue;
};

// Create a proxy-like object that dynamically resolves REACT_APP_PLACE_ID
// This maintains backward compatibility with existing code using env.REACT_APP_PLACE_ID
export const env: EnvConfig = {
  get REACT_APP_PLACE_ID(): string {
    return getPubId();
  },
};
